<template>
  <div>
    <h2>Affiliates Alerts History {{ this.affiliateId }}</h2>
    <button @click="goBack">
      <i class="fas fa-undo"></i>
      Back
    </button>
    <table>
      <thead>
      <tr class="header_history">
        <th class="text-center" v-for="header in tableHistoryHeaders">
          {{ header.name }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr style="border-bottom: 2px solid #cccccc !important"
          v-for="item in alertsHistory" :key="item.id">
        <td>{{ item.user }}</td>
        <td>{{ item.dateAdded }}</td>
        <td>
          <p v-for="(log, index) in item.logs" :key="index" class="mb-0">{{ log.field }}</p>
        </td>
        <td>{{ item.action }}</td>
        <td>
          <p v-for="(log, index) in item.logs" :key="index" class="mb-0">
            <span v-if="log.newValue">{{ log.oldValue }} &#8594; </span>
            <span>{{ log.newValue || '' }}</span>
          </p>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import affiliateAlertsApi from "@/api/affiliateAlerts";

export default {
  name: 'AffiliatesAlertsHistory',
  data() {
    return {
      affiliateId: null,
      alertsHistory: [],
      tableHistoryHeaders: [
        { name: 'User' },
        { name: 'Date/Time' },
        { name: 'Alert Type' },
        { name: 'Action' },
        { name: 'Changes' },
      ],
    };
  },
  mounted() {
    this.affiliateId = this.$route.params.id;
    this.fetchAlertsHistory(this.affiliateId);
  },
  methods: {
    goBack() {
      this.$router.push(`/affiliates/alerts/`);
    },
    async fetchAlertsHistory(affiliateId) {
      try {
        const res = await affiliateAlertsApi.getAffiliateAlertsHistoryById(affiliateId);
        this.alertsHistory = res.map(item => ({
          ...item,
          logs: JSON.parse(item.logs)
        }));
        console.log(this.alertsHistory);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ccc;
}

th {
  background-color: #fcfcfc;
}
</style>
